import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["onClick"];
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_image_cdn = _resolveComponent("image-cdn");
  return _openBlock(), _createElementBlock("nav", {
    id: "tabbar-h5",
    class: _normalizeClass({
      inNewYear2023: $setup.inNewYear2023
    })
  }, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.navs, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      key: 'tabbar-' + index
    }, [_createElementVNode("a", {
      href: "#",
      onClick: _withModifiers($event => $setup.linkTo(index), ["prevent"]),
      class: _normalizeClass({
        'active': item.isActive,
        'share': item.isShare
      })
    }, [item.isShare ? (_openBlock(), _createBlock(_component_image_cdn, {
      key: 0,
      src: item.iconDefault,
      attrs: {
        width: item.width,
        height: item.height
      }
    }, null, 8, ["src", "attrs"])) : (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: "lottie-icon",
      ref_for: true,
      ref: item.refName,
      onClick: $event => $setup.clickTab(item.refIndex, item.iconActive)
    }, null, 8, _hoisted_2)), _createElementVNode("span", null, _toDisplayString(item.title), 1)], 10, _hoisted_1)]);
  }), 128))])], 2);
}